import { render } from "./demo-file-upload.vue?vue&type=template&id=7868ecec&scoped=true"
import script from "./demo-file-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-file-upload.vue?vue&type=script&setup=true&lang=js"

import "./demo-file-upload.vue?vue&type=style&index=0&id=7868ecec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7868ecec"],['__file',"src/views/demo/demo-file-upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7868ecec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7868ecec', __exports__)) {
    api.reload('7868ecec', __exports__)
  }
  
  module.hot.accept("./demo-file-upload.vue?vue&type=template&id=7868ecec&scoped=true", () => {
    api.rerender('7868ecec', render)
  })

}


export default __exports__